/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_012: Question = {
  id: 'pres-012-plan-action-connectivite',
  oldId: '26',
  title: 'Création d\'un plan d\'action ayant pour objectif d\'augmenter la connectivité incluant des objectifs chiffrés',
  number: '2.12',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 5,
  idEM: 2,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};
const question_pres_012__v3: Question = {
  ...question_pres_012,
  title: 'Mise en oeuvre d\'un plan d\'action ayant pour objectif d\'augmenter la connectivité incluant des objectifs chiffrés',
  number: '2.10',
};
export const question_pres_012_v2: Question = question_pres_012;
export const question_pres_012_v3: Question = question_pres_012__v3;
